import { ProjectCommentService as OvermapProjectCommentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProjectCommentService extends OvermapProjectCommentService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
